
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soccer/tournament/[id]/[tab]",
      function () {
        return require("private-next-pages/soccer/tournament/[id]/[tab].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soccer/tournament/[id]/[tab]"])
      });
    }
  